import * as React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedinIn, faSquareXTwitter, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import Logo from "../icons/logo"
import "../styles/global.css";
import Helmet from "react-helmet"
import  { Link } from "gatsby"
// import { useSlideAnimation } from '../utils/gsapUtils';
import {
  footerStyle,
  logos,
  socialIcons,
  footernav,
  navigationContainer,
  footerDivider,
  copyright,
  navStyle,
  navLink,
  activeLink,
  documents,
  subfooter,
  subfooterContainer,
} from "./footer.module.css"

export function Footer({ className, version, hiddenLinks = []  }) {
  
  const isLinkHidden = (linkKey) => hiddenLinks.includes(linkKey);
  // useSlideAnimation(logos);
  //hook for page transition
  // useSlideAnimation(navLink);
  return ( 
    <div>
    <footer className={footerStyle}>
      <Link to="/" rel="alternate" hrefLang="en-SG"
       >
        <div className={logos}>
        <Logo version="white"
        />
      </div>
      </Link>
      <div className={navigationContainer}>
      {/* <Navigation className={footernav} version="white" hiddenLinks={['visit']} /> */}
      <nav className={[navStyle, footernav, className, version].join(" ")}>
      {/* <Link
        key="All"
        className={navLink}
        to="/products/"
        activeClassName={activeLink}
      >
        All products
      </Link> */}
      {/* {productTypes.map((name) => (
        <Link
          key={name}
          className={navLink}
          to={`/products/${slugify(name)}`}
          activeClassName={activeLink}
        >
          {name}
        </Link>
        <Link
        key="news"
        className={navLink}
        to="/news/"
        activeClassName={activeLink}
      >
        News
      </Link>
      <Link
        key="guide"
        className={navLink}
        to="/guide/"
        activeClassName={activeLink}
      >
        Guide
      </Link> */}
      {/* <Link
        key="booking-thanks"
        className={navLink}
        to="/booking-thanks/"
        activeClassName={activeLink}
      >
       First thank you page
      </Link>
      <Link
        key="invest-thankyou"
        className={navLink}
        to="/invest-thankyou/"
        activeClassName={activeLink}
      >
       Second thank you page
      </Link>
      ))} */}
      <Link
        key="home"
        className={`${navLink} ${isLinkHidden('home') ? 'hidden' : ''}`}
        to="/"
        activeClassName={activeLink}
        rel="alternate" hrefLang="en-SG"
      >
        HOME
      </Link>
      <Link
        key="about-us"
        className={`${navLink} ${isLinkHidden('about') ? 'hidden' : ''}`}
        to="/about/"
        activeClassName={activeLink}
        rel="alternate" hrefLang="en-SG"
      >
        About
      </Link>
     <Link
        key="artists"
        className={`${navLink} ${isLinkHidden('artists') ? 'hidden' : ''}`}
        to="/artists/"
        activeClassName={activeLink}
        rel="alternate" hrefLang="en-SG"
      >
        Artists
      </Link>
      <Link
        key="advisory"
        className={`${navLink} ${isLinkHidden('advisory') ? 'hidden' : ''}`}
        to="/advisory/"
        activeClassName={activeLink}
        rel="alternate" hrefLang="en-SG"
      >
        Advisory
      </Link>
      <a
      href="https://artworks.com.sg/#visit"
      className={`${navLink} ${isLinkHidden('visit') ? 'hidden' : ''} no-slide-animation`}
    >
      Visit
    </a>
      {/* <Link
        key="Book-Call"
        className={`${navLink} ${isLinkHidden('visit') ? 'bookcall' : ''}`}
        to="/book-call/"
        activeClassName={activeLink}
      >
        BOOK A CALL
      </Link> */}

    </nav>

      </div>
      <div className={socialIcons}>
        <a href="https://www.facebook.com/artworksSG/" target="_blank" rel="noreferrer" aria-label="Facebook">
          <FontAwesomeIcon icon={faFacebook} />
        </a>
        <a href="https://www.instagram.com/artworks_sg/" target="_blank" rel="noreferrer" aria-label="Instagram">
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a href="https://www.linkedin.com/company/art-works-sg/" target="_blank" rel="noreferrer"  aria-label="LinkedIn">
          <FontAwesomeIcon icon={faLinkedinIn} />
        </a>
        <a href="https://twitter.com/artworkssg" target="_blank" rel="noreferrer" aria-label="XTwitter">
          <FontAwesomeIcon icon={faSquareXTwitter} />
        </a>
      </div>
      <div className={footerDivider}>
        <hr/>
      </div>
    </footer>
     <div className={subfooterContainer}>
     <div className={subfooter}>
       <div className={copyright}>Copyright {new Date().getFullYear()} - All Rights Reserved.</div>
     </div>
     <Helmet>
        <script type="text/javascript">
          {`
            _linkedin_partner_id = "3975148";
            window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
            window._linkedin_data_partner_ids.push(_linkedin_partner_id);
          `}
        </script>
        <script type="text/javascript">
          {`
            (function(l) {
              if (!l) { window.lintrk = function(a, b) { window.lintrk.q.push([a, b]) }; window.lintrk.q = [] }
              var s = document.getElementsByTagName("script")[0];
              var b = document.createElement("script");
              b.type = "text/javascript"; b.async = true;
              b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
              s.parentNode.insertBefore(b, s);
            })(window.lintrk);
          `}
        </script>
        <noscript>
    {`
      <img height="1" width="1" style={{ display: 'none' }} alt="" src="https://px.ads.linkedin.com/collect/?pid=3975148&fmt=gif" rel="alternate" hrefLang="en-SG"/>
    `}
  </noscript>
      </Helmet>
     <div className={subfooter}>
       <div className={documents}>
         <Link
           key="privacy-policy"
           className={`${navLink} ${isLinkHidden('Privacy Policy') ? 'hidden' : ''}`}
           to="/privacy-policy/"
           activeClassName={activeLink}
           target="_blank"
           rel="alternate" hrefLang="en-SG"
         >
           Privacy Policy
         </Link>
         <Link
           key="terms-and-conditions"
           className={`${navLink} ${isLinkHidden('Terms and Conditions') ? 'hidden' : ''}`}
           to="/terms-and-conditions/"
           activeClassName={activeLink}
           target="_blank"
           rel="alternate" hrefLang="en-SG"
         >
           Terms and Conditions
         </Link>
       </div>
     </div>
   </div>
   </div>
  )
}
